/**
 * Resolves column width for table headers and cells. Supports fixed pixels (e.g. "140") and percentages (e.g. "18%").
 * Returns null when the column should size automatically.
 * @param {string | undefined} width raw width value from table column config
 * @returns {string | null} css width value or null for auto sizing
 */
export function resolveTableColumnWidth(width: string | undefined): string | null {
  if (width == null) {
    return null;
  }

  const w = width.trim();

  if (w === '' || w === 'auto') {
    return null;
  }

  if (w.endsWith('%')) {
    return w;
  }

  if (/^\d+(\.\d+)?$/.test(w)) {
    return `${w}px`;
  }

  return w;
}
